import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
// import { contentSpacingStyles } from "@tSurya/theme/mixins";
// import breakpointValuesMediaQueries from "@tSurya/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

export default {
    fontFamilyImportUrl:
        "https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&display=swap",
    body: {
        fontFamily: TYPOGRAPHY.fontFamily.base,
        lineHeight: TYPOGRAPHY.lineHeight.xbase,
        size: TYPOGRAPHY.size.small,
        weight: TYPOGRAPHY.weight.base,
        color: getColor("text.main"),
    },
    p: {
        fontFamily: TYPOGRAPHY.fontFamily.base,
        size: TYPOGRAPHY.size.smaller,
        weight: TYPOGRAPHY.weight.base,
        lineHeight: TYPOGRAPHY.lineHeight.base,
        color: getColor("text.main"),
    },
    h1: {
        size: 36,
        weight: TYPOGRAPHY.weight.mediumbold,
        lineHeight: TYPOGRAPHY.lineHeight.largest,
        fontFamily: TYPOGRAPHY.fontFamily.base,
        color: getColor("text.main"),
    },
    h2: {
        size: 28,
        weight: TYPOGRAPHY.weight.mediumbold,
        lineHeight: TYPOGRAPHY.lineHeight.larger,
        fontFamily: TYPOGRAPHY.fontFamily.base,
    },
    h3: {
        size: 24,
        weight: TYPOGRAPHY.weight.mediumbold,
        lineHeight: TYPOGRAPHY.lineHeight.xxmedium,
        fontFamily: TYPOGRAPHY.fontFamily.base,
    },
    h4: {
        size: 20,
        weight: TYPOGRAPHY.weight.bold,
        lineHeight: TYPOGRAPHY.lineHeight.lmedium,
        fontFamily: TYPOGRAPHY.fontFamily.base,
    },
    h5: {
        size: 18,
        weight: TYPOGRAPHY.weight.bold,
        lineHeight: TYPOGRAPHY.lineHeight.medium,
        fontFamily: TYPOGRAPHY.fontFamily.base,
    },
    h6: {
        size: 16,
        weight: TYPOGRAPHY.weight.bold,
        lineHeight: TYPOGRAPHY.lineHeight.xbase,
        fontFamily: TYPOGRAPHY.fontFamily.base,
    },
    headerPrimary: {
        transform: "none",
        size: 15,
        weight: TYPOGRAPHY.weight.mediumbold,
        lineHeight: TYPOGRAPHY.lineHeight.base,
        fontFamily: TYPOGRAPHY.fontFamily.base,
    },
    headerSecondary: {
        size: 15,
        transform: "none",
        fontFamily: TYPOGRAPHY.fontFamily.base,
        lineHeight: TYPOGRAPHY.lineHeight.base,
        weight: TYPOGRAPHY.weight.mediumbold,
    },
    headerTertiary: {
        transform: "uppercase",
        size: 14,
        lineHeight: TYPOGRAPHY.lineHeight.lsmall,
        weight: TYPOGRAPHY.weight.base,
        fontFamily: TYPOGRAPHY.fontFamily.base,
    },
    link: {
        size: 15,
        weight: TYPOGRAPHY.weight.bold,
        lineHeight: TYPOGRAPHY.lineHeight.base,
        color: getColor("text.main"),
    },
};
